// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover_popover__1nun7","shown":"popover_shown__pQNNM","arrow":"popover_arrow__F4eOJ","content":"popover_content__3bk6w","inner":"popover_inner__3dLfl"};